import * as zod from 'zod';

export default zod.object({});
